exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".fade-enter-active[data-v-df9f821c],.fade-leave-active[data-v-df9f821c]{-webkit-transition:opacity .2s;transition:opacity .2s}.fade-enter[data-v-df9f821c],.fade-leave-to[data-v-df9f821c]{opacity:0}", ""]);

// exports
